import styled from 'styled-components'

export const TitleChart = styled.h2`
  font-size: 24px;
  font-weight: 500;
  margin-left: 15px;
  margin-top: 30px;
`
